import React, { useContext, useEffect, useState } from 'react';
import { IonApp } from '@ionic/react';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { Provider } from 'react-redux';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
//import '@ionic/react/css/padding.css';
//import '@ionic/react/css/float-elements.css';
//import '@ionic/react/css/text-alignment.css';
//import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './theme/custom.scss';

// Redux
import { store } from './redux';

// Contexts
import { AppContext } from './contexts';

// Routes
import { AppRouter } from './routes/AppRouter';

// Helpers
import { isNative, startAnalytics } from './helpers';

// Guards
import { NetworkGuard } from './guards';

const App = () => {

  const { isWeb } = useContext(AppContext);
  const [network, setNetwork] = useState({});

  // Si no es web, bloquea la orientación del dispositivo a portrait
  if (isNative()) {

    ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.PORTRAIT);
  }

  /**
   * Controla la conexión a internet
   */
  useEffect(() => {

    const networkGuard = new NetworkGuard(setNetwork);
    networkGuard.init();
    
    return () => {

      networkGuard.end();
    }

  }, []);

  /**
   * Inicia la escucha para las métricas de Analytics
   */
  useEffect(() => {
    
    startAnalytics();
    
  }, []);  
  
  return (

    <IonApp>      

      <Provider store={store}>
        <AppContext.Provider value={{
          isWeb,
          network
        }}>
          <div className="animate__animated animate__fadeIn slow">
            <AppRouter />
          </div>

        </AppContext.Provider>
      </Provider>

    </IonApp>

  );

};

export default App;
